import React from 'react';

const Contact = () => {
    return (
        <div className='pt-28 overflow-x-hidden' id='contact'>
            <div className="container mx-auto pb-28 px-5">
                <div className='text-center space-y-8'>
                    <h4 data-aos="fade-right" className='uppercase text-lg text-white font-thin tracking-[6px]'>Contact Us</h4>
                    <h2 data-aos="fade-left" className='text-4xl md:text-6xl color-font'>Let’s Get in Touch And Make <br /> Magic Together.</h2>
                </div>

                <div className='pt-20'>
                    <form action="">
                        <div className="grid grid-cols-2 gap-8">
                            <div data-aos="fade-right">
                                <input type="text" placeholder="Name" className="bg-[#09090B] border-b border-base-content focus:outline-none p-3 w-full" />
                            </div>
                            <div data-aos="fade-left">
                                <input type="email" placeholder="Email" required className="bg-[#09090B] border-b border-base-content focus:outline-none p-3 w-full" />
                            </div>
                            <div data-aos="fade-down" className='col-span-2'>
                                <textarea className="bg-[#09090B] border-b border-base-content focus:outline-none p-3 rounded w-full" placeholder="Message"></textarea>
                            </div>
                            <div data-aos="fade-up" className="col-span-2 text-center">
                                <button className='btn'>Send Message</button>
                            </div>
                        </div>
                    </form>
                </div>


            </div>
            {/* <div className="w-3/5 h-1 bg-gradient-to-l from-neutral-content absolute right-0 z-50"></div> */}


        </div>
    );
};

export default Contact;